/**
 * Portfolio Tab切换管理组件（遵循 MarketplaceTabs 的结构与样式）
 * - 受控：activeTab 与 onChange 由上层控制
 */

"use client";

import React, { useMemo } from "react";
import { cn } from "utils";
import { ShellLink } from "@/src/components";
import { getPortfolioTabs, PortfolioTabId } from "../tabsConfig";
import { PortfolioTabSearch } from "@/src/components/Portfolio/Search";
import { PortfolioAsset } from "@/src/features/api/openData";
import { ROUTER_PATH } from "@/src/config";

export interface PortfolioTabsProps {
  activeTab: PortfolioTabId;
  portfolioId: string;
  className?: string;
  onSearchSelect?: (asset: PortfolioAsset) => void;
  onSearchClear?: () => void;
}

export const PortfolioTabs: React.FC<PortfolioTabsProps> = ({
  activeTab,
  portfolioId,
  className,
  onSearchSelect,
  onSearchClear,
}) => {
  const portfolioTabs = useMemo(() => getPortfolioTabs(), []);
  return (
    <div
      className={cn(
        "flex justify-between items-center border-b border-border_white_transparent10 w-full md:px-0 px-4 md:static",
        className,
      )}
    >
      <tab-indicator
        className="flex gap-6 overflow-x-auto no-scrollbar [--underline-color:var(--edgen-border\_brand\_solid)] [--animation-duration:0.2s]"
        effect="underline"
      >
        {portfolioTabs.map((item) => (
          <ShellLink
            title={item.label}
            aria-label={item.label}
            data-openreplay-label={`${`${item.label} Link`} | ${`${ROUTER_PATH.PORTFOLIO}/${item.id}/${portfolioId}`}`}
            id="lnk-portfolio-tabs"
            href={`${ROUTER_PATH.PORTFOLIO}/${item.id}/${portfolioId}`}
            key={item.id}
            role="tab-item"
            data-actived={activeTab === item.id}
            className="tab_item flex-shrink-0"
            prefetch={true}
            replace={true}
          >
            <span className="py-[6px] button_l text-content_primary">
              {item.label}
            </span>
          </ShellLink>
        ))}
      </tab-indicator>
      <PortfolioTabSearch
        onSelect={onSearchSelect}
        onClear={onSearchClear}
        portfolioId={portfolioId}
      />
    </div>
  );
};
